import { useTenantData } from "contexts/tenant";
import { Period } from "hooks/periodIndex";
import { PlanId } from "../boundary/PlanId";
import {
  EditableMixTable,
  EditableMixTableProps,
  shouldShowNameOverride,
} from "./EditableMixTable";
import { useColumnGroupingModel } from "./useColumnGroupingModel";
import { useFilterModel } from "./filterModel";
import { Row } from "./types";

type Props = Omit<
  EditableMixTableProps,
  "columnGroupingModel" | "filterModel" | "hasDri" | "onChange"
> & {
  planId: PlanId;
  period: Period;
  driInventory: number | null;
  showInventory?: boolean;
  onChange: (planId: PlanId, period: Period, rows: Row[]) => void;
};

export const DeployTable = ({
  planId,
  period,
  driInventory,
  showInventory = true,
  onChange,
  ...props
}: Props) => {
  const { default_mix_breakdown, small_mass_per_mass } = useTenantData();
  const massScaleFactor =
    props.massScaleFactorOverride ??
    (default_mix_breakdown === "small_mass" ? small_mass_per_mass : 1);
  const hasNameOverride = shouldShowNameOverride(
    props.nameOverrideOptions,
    props.mixIdsRequiringNameOverride
  );
  const columnGroupingModel = useColumnGroupingModel(
    planId,
    period,
    massScaleFactor,
    props.materials,
    driInventory,
    props.isPercentageModeOverride ?? false,
    showInventory,
    hasNameOverride
  );
  const filterModel = useFilterModel(planId, period, "deploy");
  return (
    <EditableMixTable
      {...props}
      columnGroupingModel={columnGroupingModel}
      filterModel={filterModel}
      hasDri={driInventory !== null}
      onChange={(rows) => {
        onChange(planId, period, rows);
      }}
    />
  );
};
